import React, { memo } from 'react';
import { getBackgroundByKey } from '@send-services/resources';

const SideImage = memo(() => {
  const url = getBackgroundByKey({ key: 'side_image', default: 'static/images/side_image.jpg' });
  return <div className="side-image" style={{ backgroundImage: `url(${url})` }} />;
});

export default SideImage;
